import IconSearchPage from './IconSearchPage';

export default IconSearchPage;
